/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayAutoRestart_ConfigFragment = { __typename: 'ConfigurationModel', id: string, autoRestart?: { __typename: 'ConfigAutoRestartState', reported: { __typename: 'ConfigAutoRestart', switch: string, time?: string | null } } | null };

export type ConfigUpdateAutoRestartMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateAutoRestartInput;
}>;


export type ConfigUpdateAutoRestartMutation = { __typename: 'Mutation', configurationUpdateAutoRestart: { __typename: 'ConfigurationModel', id: string, autoRestart?: { __typename: 'ConfigAutoRestartState', reported: { __typename: 'ConfigAutoRestart', switch: string, time?: string | null } } | null } };

export const ConfigDisplayAutoRestart_ConfigFragmentDoc = gql`
    fragment ConfigDisplayAutoRestart_config on ConfigurationModel {
  id
  autoRestart {
    reported {
      switch
      time
    }
  }
}
    `;
export const ConfigUpdateAutoRestartDocument = gql`
    mutation ConfigUpdateAutoRestart($input: ConfigurationUpdateAutoRestartInput!) {
  configurationUpdateAutoRestart(input: $input) {
    id
    ...ConfigDisplayAutoRestart_config
  }
}
    ${ConfigDisplayAutoRestart_ConfigFragmentDoc}`;
export type ConfigUpdateAutoRestartMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateAutoRestartMutation, ConfigUpdateAutoRestartMutationVariables>;

/**
 * __useConfigUpdateAutoRestartMutation__
 *
 * To run a mutation, you first call `useConfigUpdateAutoRestartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateAutoRestartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateAutoRestartMutation, { data, loading, error }] = useConfigUpdateAutoRestartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateAutoRestartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateAutoRestartMutation, ConfigUpdateAutoRestartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateAutoRestartMutation, ConfigUpdateAutoRestartMutationVariables>(ConfigUpdateAutoRestartDocument, options);
      }
export type ConfigUpdateAutoRestartMutationHookResult = ReturnType<typeof useConfigUpdateAutoRestartMutation>;
export type ConfigUpdateAutoRestartMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateAutoRestartMutation>;
export type ConfigUpdateAutoRestartMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateAutoRestartMutation, ConfigUpdateAutoRestartMutationVariables>;